export default __webpack_public_path__ + "static/media/LandingPageFive.0143cbea.png";